import { useMapEvents } from "react-leaflet";

const ClickHandler = ({ onClick, isMapClickable }) => {
  useMapEvents({
    click: (e) => {
      // فقط زمانی که کلیک فعال است، مختصات را تنظیم کن
      if (isMapClickable) {
        if (onClick) {
          onClick(e.latlng); // ارسال مختصات کلیک
        }
      }
      // در غیر این صورت هیچ کاری نمی‌کند
    },
  });

  return null;
};

export default ClickHandler;
